/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { DataOwnerTypeEnum } from './DataOwnerTypeEnum'
import { HealthcareParty } from './HealthcareParty'
import { Patient } from './Patient'
import { Device } from './Device'

export type DataOwnerWithType =
  | { type: DataOwnerTypeEnum.Hcp; dataOwner: HealthcareParty }
  | { type: DataOwnerTypeEnum.Patient; dataOwner: Patient }
  | { type: DataOwnerTypeEnum.Device; dataOwner: Device }
export namespace DataOwnerWithType {
  export function fromJson(json: any | JSON): DataOwnerWithType {
    if (json.type === DataOwnerTypeEnum.Hcp) {
      return { type: DataOwnerTypeEnum.Hcp, dataOwner: new HealthcareParty(json.dataOwner) }
    } else if (json.type === DataOwnerTypeEnum.Patient) {
      return { type: DataOwnerTypeEnum.Patient, dataOwner: new Patient(json.dataOwner) }
    } else if (json.type === DataOwnerTypeEnum.Device) {
      return { type: DataOwnerTypeEnum.Device, dataOwner: new Device(json.dataOwner) }
    } else throw new Error(`Unknown data owner type ${json.type}`)
  }
}
